import { useEffect } from "react";
import useDataProviderStatus from "../hooks/useDataProviderStatus";
import useInitialLoaderActions from "../providers/InitialLoaderProvider/useInitialLoaderActions";

interface AppInitialLoaderProps {
  children: React.ReactNode;
}

/**
 * AppInitialLoader is a component that manages the initial loading state of the application.
 *
 * It checks the status of data providers, meaning the user was verified and the essential data
 * is available, and updates the loading state accordingly.
 */
function AppInitialLoader(props: AppInitialLoaderProps) {
  const status = useDataProviderStatus();
  const onSetLoading = useInitialLoaderActions();

  useEffect(() => {
    if (status === "success") {
      onSetLoading(false);
    }
  }, [status, onSetLoading]);

  if (status === "fetching") return <span />;

  return <>{props.children}</>;
}

export default AppInitialLoader;
